enum OptionType {
  WITH_ICON = 'WITH_ICON',
  MAIN_TAB = 'MAIN_TAB',
  ADDITIONAL_TAB = 'ADDITIONAL_TAB',
}
export {OptionType}
